export default "__VITE_ASSET__BO61EWN8__"